module.exports = __webpack_public_path__ + "img/電気回路_4_6_3.146fdec9.png";